import { IStorefrontSettings } from '../../Api/Models/StorefrontSettings';

// The unified global style config (styleConfig) authored in the ac-main admin. Styles are read
// JSON-first, falling back to the individual legacy fields on the settings object, so existing
// storefronts (which only have the legacy fields) keep rendering unchanged.

const STYLE_KEYS = [
    'menuBarColor',
    'menuBarTextColor',
    'backgroundColor',
    'textColor',
    'headerFont',
    'defaultFont',
    'sectionBackgroundColor',
    'sectionHeaderBackgroundColor',
    'sectionFooterBackgroundColor',
] as const;

function parse(raw?: string): Record<string, string | undefined> {
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
        return {};
    }
}

// Returns the settings with styleConfig values applied over the legacy style fields. Any key present
// in styleConfig (including an empty string meaning "cleared") wins over the legacy field.
export function applyStyleConfig<T extends IStorefrontSettings | undefined>(settings: T): T {
    if (!settings || !settings.styleConfig) return settings;
    const cfg = parse(settings.styleConfig);
    const overrides: Record<string, string> = {};
    for (const k of STYLE_KEYS) {
        if (cfg[k] !== undefined) overrides[k] = cfg[k] as string;
    }
    return { ...settings, ...overrides };
}
